<template>
  <div class="header-main-box">
    <div class="header-left-content">
      欢迎登录安管人员安全生产知识 考试系统！
    </div>
    <div class="header-right-content">
      <div class="right-user-box">
        <div class="user-img-box">
          <a-avatar class="avatar" shape="circle" size="small" icon="user" />
        </div>
        <div class="user-name-box">{{ getUserInfo.name }}</div>
      </div>
      <div class="right-unlogin-icon" @click="signOut">
        <a-icon type="poweroff" />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

import { removeToken } from '@/utils/auth'
import { userLogoutAPI } from '@/api/loginOrRegist'

export default {
  name: 'mainHander',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getUserInfo']),
  },
  methods: {
    signOut() {
      removeToken()
      store.commit('removeUserInfo')
      this.$router.push('/login')
      userLogoutAPI().then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.header-main-box {
  width: 100vw;
  height: 4rem;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0rem 0.31rem 0.56rem 0rem rgba(229, 229, 229, 0.5);
  padding: 0 1.5rem;
  font-size: 0.88rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;

  .header-left-content {
    line-height: 4rem;
  }
  .header-right-content {
    display: flex;
    .right-user-box {
      display: flex;
      align-items: center;
      cursor: pointer;

      .user-img-box {
        width: 2rem;
        height: 2rem;
        .avatar {
          margin-top: 0.2rem;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .user-name-box {
        margin-left: 0.5rem;
      }
    }
    .right-unlogin-icon {
      line-height: 4rem;
      margin-left: 1.56rem;
      color: #3c6aff;
      cursor: pointer;
    }
  }
}
</style>
